import { Header } from "./components/Header";
import { AllRoutes } from "./routes/AllRoutes";

function App() {
  return (
    <>
      <Header />
      <AllRoutes />
    </>
  );
}

export default App;
